// extracted by mini-css-extract-plugin
export var o_footer = "footer-module--o_footer--f7414";
export var o_footer__col = "footer-module--o_footer__col--78b60";
export var o_footer__cols = "footer-module--o_footer__cols--6ab2d";
export var o_footer__container = "footer-module--o_footer__container--4e370";
export var o_footer__copyright = "footer-module--o_footer__copyright--68b4c";
export var o_footer__grid = "footer-module--o_footer__grid--530f2";
export var o_footer__logo = "footer-module--o_footer__logo--10093";
export var o_footer__logocaja = "footer-module--o_footer__logocaja--18294";
export var o_footer__logos = "footer-module--o_footer__logos--5e363";
export var o_footer__magenta = "footer-module--o_footer__magenta--9d556";
export var o_footer__siguenos = "footer-module--o_footer__siguenos--10632";
export var o_footer__title = "footer-module--o_footer__title--c05a5";
export var o_footer__version = "footer-module--o_footer__version--ef6e9";
export var o_footer__vigilado = "footer-module--o_footer__vigilado--521d8";